import { useLayoutEffect, useRef, useState } from 'react';

/**
 * Textarea com floating label que começa em 1 linha e cresce com o conteúdo
 * (auto-grow), + um botão discreto de expandir (estica pra ~meia tela) no canto.
 * Usado no "Objeto do serviço" e nas "Anotações sobre o cliente" da OS.
 */
export function CustomAutoTextarea({
  id,
  label,
  value,
  onChange,
  placeholder,
}: {
  id: string;
  label: string;
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
}) {
  const ref = useRef<HTMLTextAreaElement>(null);
  const [expandido, setExpandido] = useState(false);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (expandido) {
      el.style.overflow = 'auto';
      el.style.height = '50vh';
    } else {
      el.style.overflow = 'hidden';
      el.style.height = 'auto';
      el.style.height = `${el.scrollHeight}px`;
    }
  }, [value, expandido]);

  return (
    <div className="form-floating position-relative">
      <textarea
        ref={ref}
        id={id}
        className="form-control"
        rows={1}
        style={{ minHeight: 'calc(3.5rem + 2px)', resize: 'none' }}
        placeholder={placeholder ?? label}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <label htmlFor={id}>{label}</label>
      <button
        type="button"
        className="btn btn-sm btn-link position-absolute top-0 end-0 p-1 text-secondary"
        style={{ zIndex: 5 }}
        onClick={() => setExpandido((v) => !v)}
        title={expandido ? 'Recolher' : 'Expandir'}
      >
        <i
          className={`bi ${
            expandido ? 'bi-arrows-angle-contract' : 'bi-arrows-angle-expand'
          }`}
        ></i>
      </button>
    </div>
  );
}
